import { render, staticRenderFns } from "./VDataHistory.vue?vue&type=template&id=5fe349de&lang=pug"
import script from "./VDataHistory.vue?vue&type=script&lang=ts"
export * from "./VDataHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports